import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
const apiBase = process.env.REACT_APP_API;

const Timer = ({ lessonId, initialTimeLeft, onTimeOver }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialTimeLeft * 60);
  const lastSyncedMinuteRef = useRef(null);
  const timerEndedRef = useRef(false); // To avoid multiple calls to onTimeOver

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 0) return 0;

        const newSeconds = prev - 1;

        const currentMinute = Math.floor(newSeconds / 60);
        if (currentMinute !== lastSyncedMinuteRef.current) {
          lastSyncedMinuteRef.current = currentMinute;
          updateTimeOnServer(currentMinute);
        }

        return newSeconds;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (secondsLeft === 0 && !timerEndedRef.current) {
      timerEndedRef.current = true;
      if (onTimeOver) {

        updateTimeOnServer(0)
        onTimeOver();
      }
    }
  }, [secondsLeft, onTimeOver]);

  const updateTimeOnServer = async (minuteLeft) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${apiBase}/lessons/user/video/${lessonId}`,
        { timeLeft: minuteLeft },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('Time updated on server:', minuteLeft);
    } catch (error) {
      console.error('Failed to update time:', error);
    }
  };

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  return (
    <div className="justify-end bg-myBlue text-white p-4 rounded-lg shadow-lg w-fit">
      <div className="text-3xl font-mono">
        {minutes.toString().padStart(2, '0')} : {seconds.toString().padStart(2, '0')}
      </div>
    </div>
  );
};

export default Timer;
